import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiHelperService } from 'projects/apna-lib/src/lib/services/api-helper.service';
import { ConfigService } from 'projects/apna-lib/src/lib/services/config.service';
import { TwoWayBindService } from 'projects/apna-lib/src/lib/services/two-way-bind.service';
import { UserIdentityService } from 'projects/apna-lib/src/lib/services/user-identity.service';

export interface BulkUploadData {
  studentId: string;
}

@Component({
  selector: 'fa-bulk-upload',
  templateUrl: './bulk-upload.component.html',
  styleUrls: ['./bulk-upload.component.scss']
})
export class BulkUploadComponent implements OnInit {
  @Input() data: BulkUploadData;
  @Output() stepBulk = new EventEmitter<string>();
  layout: FormlyFieldConfig[] = [
    {
      fieldGroupClassName: "row justify-content-center",
      fieldGroup: [
        {
          className: "col-12",
          key: 'file',
          type: 'files',
          templateOptions: {
            required: true,
            label: "Documents",
            bulk: true,
            placeholder: "Drag or browse and upload your document",
            desc: "Doc format: .jpg, .jpeg, .png, .pdf. (Doc Size: <5Mb, Max 30 documents at a time)",
            fileWrapperClass: "py-3 py-md-3",
            attributes: {
              multiple: "multiple",
            }
          }
        },
        {
          className: "col-12 col-md-4 mx-md-auto justify-content-lg-between w-lg-100",
          type: "button",
          templateOptions: {
            btnType: 'primary gradient w-custom',
            text: "Save",
            onClick: () => {
              if (this.model?.file === undefined || this.model?.file === "") {
                this.model["error"] = "Hello world"
              }
            },

          },
          hideExpression: () => {
            if (this.model?.file === undefined || this.model?.file === "" || this.model?.file === null) {
              return true;
            }
            return false;
          }
        }
      ]
    }
  ];
  model: any = {};
  dataModel: string = "user-documents";
  dataSource: any;
  columnDefs: any[];
  otherDocumentData: any;
  modelId: string;
  userDetails: any;

  constructor(
    private apiHelper: ApiHelperService,
    private user: UserIdentityService,
    private config: ConfigService,
    private spinner: NgxSpinnerService,
    private activatedRoute: ActivatedRoute,
    private twoWay: TwoWayBindService
  ) {
    this.userDetails = user.getUserDetails();
  }

  ngOnInit(): void {
    this.dataPreprocessor();
  }

  dataPreprocessor() {
    if (this.activatedRoute?.snapshot?.queryParams?.hasOwnProperty("referenceId") && this.activatedRoute.snapshot?.queryParams?.hasOwnProperty("token")) {
      const referenceId = this.activatedRoute?.snapshot?.queryParams?.referenceId;
      const token = this.activatedRoute.snapshot.queryParams.token;
      localStorage.setItem("token", token);
      localStorage.setItem("userId", referenceId);
      localStorage.setItem("ttl", "3600")
      this.apiHelper.getDataById(this.dataModel, referenceId).subscribe((data: any) => {
        if (data?.id) {
          this.modelId = data?.id;
        }
        if (data?.otherDocuments) {
          this.otherDocumentData = { ...data?.otherDocuments };
        }
      })
    }
    else {
      this.apiHelper.getDataById(this.dataModel, this.data?.studentId).subscribe((data: any) => {
        if (data?.id) {
          this.modelId = data?.id;
        }
        if (data?.otherDocuments) {
          this.otherDocumentData = { ...data?.otherDocuments };
        }

      })
    }

  }

  getDocumentName(url: string) {
    return this.config.getDocumentNameFromUrl(url);
  }

  downloadDocument(url: string, ev: any) {
    ev.stopPropagation();
    let result = "";
    if (url && url.indexOf("com/") > 0) {
      const [, pathVariable] = url.split("com/");
      const [folderName, fileName] = pathVariable.split("/");
      this.spinner.show();
      this.apiHelper.generateSignedUrl(folderName, fileName)
        .subscribe(({ signedUrl }: { signedUrl: string }) => {
          this.spinner.hide();
          result = signedUrl;

          window.open(signedUrl, '_blank')
        },
          error => {
            this.spinner.hide();
          });
    }
  }

  deleteDocument(url: string, ev: any) {
    ev.stopPropagation();
    this.otherDocumentData.other.filePath = this.otherDocumentData.other.filePath.filter((single: string) => url != single);
    this.otherDocumentData.other["uploadedById"] = this.userDetails.id;
    this.otherDocumentData.other["uploadedDate"] = new Date();
    this.apiHelper.updateData(this.dataModel, this.modelId, { otherDocuments: { ...this.otherDocumentData } }).subscribe((data: any) => {
      this.apiHelper.openSnackBar("Removed Document Successfully!");
      this.dataPreprocessor();
    });

  }

  dataProcessor(data: any) {
    let reqObj = {} as any;

    if (data?.error) {
      delete data?.error;
      this.model.error = undefined;
    }

    if (this.otherDocumentData && this.otherDocumentData?.other) {
      let files = [];
      if (this.otherDocumentData?.other.filePath?.length > 0) {
        this.otherDocumentData?.other.filePath?.push(...data?.file);
        files = this.otherDocumentData?.other?.filePath;
      }
      else {
        files = data?.file
      }
      reqObj["otherDocuments"] = { ...this.otherDocumentData };
      reqObj.otherDocuments = {
        other: {
          filePath: files,
          uploadedById: this.userDetails?.id,
          uploadedDate: new Date()
        }
      }
    }
    else {
      reqObj["userId"] = this.userDetails?.id;
      reqObj["otherDocuments"] = {
        other: {
          uploadedById: this.userDetails?.id,
          uploadedDate: new Date(),
          filePath: data?.file
        }
      }
    }
    if (this.modelId) {
      reqObj["id"] = this.modelId.toString();
    }
    reqObj["uploadType"] = "bulkUpload";
    return reqObj;
  }

  onSubmitResponse(ev: any) {
    if (!ev?.error) {
      this.dataPreprocessor();
      this.stepBulk.emit("showThankYouBulk")
    }
  }

}
